var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85353 11.4251C9.5297 11.6181 9.16361 11.7195 8.79113 11.7195C8.41864 11.7195 8.05255 11.6181 7.72873 11.4251L2.9195 8.3311C2.9195 8.3311 2.4823 8.05149 2.4823 8.68405V11.778C2.4823 13.4053 5.30663 15.1597 8.79113 15.1597C12.2756 15.1597 15.0989 13.4053 15.0989 11.778V8.51101C15.0989 8.00337 14.7906 8.25089 14.7906 8.25089L9.85353 11.4251Z",
    fill: "#9B9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2872 5.18756C17.6796 4.93545 17.6796 4.52177 17.2872 4.27081L9.50942 0.189023C9.29013 0.0649562 9.04486 0 8.79568 0C8.54651 0 8.30124 0.0649562 8.08195 0.189023L0.294292 4.26967C-0.0980972 4.52177 -0.0980972 4.93431 0.294292 5.18641L8.07758 10.1918C8.29687 10.3159 8.54213 10.3808 8.79131 10.3808C9.04049 10.3808 9.28576 10.3159 9.50504 10.1918L17.2872 5.18756Z",
    fill: "#9B9B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1797 13.9653V7.11496C17.1797 7.11496 17.1797 6.86859 17.0442 6.94995C16.8415 7.07888 16.6459 7.21966 16.4584 7.37165C16.3491 7.47364 16.372 7.70168 16.372 7.70168V13.9504C16.3824 14.0544 16.4295 14.1506 16.5042 14.22C16.5789 14.2893 16.6756 14.3268 16.7753 14.3251C16.8735 14.3291 16.9694 14.2943 17.0443 14.2277C17.1192 14.1611 17.1675 14.0675 17.1797 13.9653Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/Courses.28e0e416fe32c1ca217b8af9389c67c4.svg";
export { ForwardRef as ReactComponent };